module.exports = __webpack_public_path__ + "docs/privacy.939a96ce6dd974d5f804651cff4f37e4.html";